<template>
    <u-select-outlined-rounded v-model="modelValue" v-bind="$attrs" class="v-text-field--label-inner rounded-pill" @input="$emit('input', modelValue)">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-select-outlined-rounded>
</template>

<script>
import USelectOutlinedRounded from "@/components/publish/styles/forms/u-select-outlined-rounded.vue";

export default {
    props: {
        value: { type: String, default: null },
    },
    components: {
        USelectOutlinedRounded,
    },
    data() {
        return {
            modelValue: this.$props.value,
        };
    },
    watch: {
        value() {
            this.modelValue = this.value;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
